// extracted by mini-css-extract-plugin
export default {"container":"listsubcategory_container__ftrkn"};